import { KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { noSort } from 'src/app/core/api/model-utils';
import { AccessState } from 'src/app/core/schemas/subscription-plan.schema';
import { SubscriptionPlanAccessService } from 'src/app/core/services/subscription-plan-access.service';
import { ClinicSetupService } from './../clinic-setup.service';
import { LayoutsService } from './layouts.service';

@Component({
  selector: 'csi-layouts',
  templateUrl: './layouts.component.html',
  styleUrls: ['./layouts.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutsComponent implements OnInit {
  private _isSaving: boolean = false;
  @Input('isSaving') set isSaving(value) {
    this._isSaving = value;
  }

  get isSaving() {
    return this._isSaving;
  }
  disclaimerMap: { [key: string]: string } = {};

  layoutFriendlyKeyValues: KeyValue<string, any>[] = [];

  public noSort = noSort;

  public layoutsCopy = JSON.parse(JSON.stringify(this.layoutsService.allLayoutsById));

  public readonly AccessState = AccessState;

  constructor(
    public layoutsService: LayoutsService,
    public clinicSetupService: ClinicSetupService,
    private cdr: ChangeDetectorRef,
    public subscriptionPlanAccessService: SubscriptionPlanAccessService
  ) {}

  ngOnInit(): void {
    this.layoutFriendlyKeyValues = Object.entries(this.layoutsCopy).map(([key, value]) => ({
      key,
      value
    }));

    Object.keys(this.layoutsCopy).forEach(layoutKey => {
      this.disclaimerMap[layoutKey] = this.layoutsService.getDisclaimer(layoutKey, 'Symptoms');
    });

    this.cdr.detectChanges();
  }

  sortKeyValues(a: KeyValue<string, any>, b: KeyValue<string, any>): number {
    return 0;
  }
}
